import { useQuery, UseQueryResult } from "@tanstack/react-query";
import axios from "axios";
import { useAuthStore } from "../../../../console/store/useAuthStore";
import { enum_api_uri } from "../../utils/enum";
import axiosInstance from "../axiosInstance";

export interface SalesData {
    special: boolean;
    customer_idx: number;
    customer_name: string;
    customer_manager_name: string;
    customer_manager_mobile: string;
    member_count: number;
    order_count: number;
    sales_amount: number;
    pending_count: number;
    payment_complete_count: number;
    payment_date: string;
    payment_amount: number;
    pending_amount: number;
    payment_status: number;
    payment_status_text: string;
}

interface GetSalesResponse {
    limit: number;
    current_page: number;
    start_page: number;
    max_page: number;
    last_page: number;
    end_page: number;
    total_count: number;
    data_list: SalesData[];
}

interface GetSalesParams {
    page: number;
    limit: number;
    searchtxt?: string;
    field?: string;
    direction?: string;
    status?: number;
}

export const useGetSalesList = (params: GetSalesParams): UseQueryResult<GetSalesResponse, Error> => {
    const accessToken = useAuthStore(state => state.accessToken);

    return useQuery<GetSalesResponse, Error>({
        queryKey: ["getSalesList", params],
        queryFn: async () => {
            const response = await axiosInstance.get(`${enum_api_uri.get_sales}`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
                params: {
                    page: params.page,
                    limit: params.limit,
                    search: "customer_name",
                    searchtxt: params.searchtxt,
                    field: params.field,
                    direction: params.direction,
                    ...(params.status === 1 ? { payment_status: params.status } : {}),
                },
            });
            return response.data.data;
        },
        placeholderData: prevData => {
            if (prevData) {
                return {
                    ...prevData,
                    current_page: params.page,
                };
            }
            return undefined;
        },
    });
};
